import React, { useMemo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/TableContainer';
import { getClients as onGetClient } from "../../store/clients/getclients/action"
import { getClientStatus as onGetStatus } from "../../store/clients/clientstatus/action"
import { useSelector, useDispatch } from "react-redux";
import { UncontrolledTooltip } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import DeleteModal from '../../components/Common/DeleteModal'
import PageLoader from '../../components/Common/PageLoader'
import NoDataFound from '../../components/Common/NoDataFound'
import { bool } from 'yup';
import { set } from 'lodash';
import TableSkeleton from 'components/Common/TableSkeleton';
import Skeleton from 'react-loading-skeleton';

const ClientsList = () => { 
    const client = useSelector(state => ({
        client: state.Clients.client
    }))
    const { loader, clientStatus } = useSelector(state => ({
        clientStatus:  state.ClientStatus,
        loader: state.ClientStatus.loader
    }))
    //delete customer
    const [deleteModal, setDeleteModal] = useState(false);
    const [checked, setChecked] = useState(false);
    const [isGetid, setIsId] = useState('');
    const clientActiveEvent = () => {
        dispatch(onGetStatus(checked, isGetid, history));
        setDeleteModal(true);
    };
    const handleClientId = _id => {
        setIsId(_id._id)
        setDeleteModal(true);
    };
    const history = useHistory();
    const newClientRouter = () => {
        history.push("/clients/add-new-client");
    }
    const dispatch = useDispatch();
    const [reload, setReload] = useState(0)
    const getAllClients = () => {
        dispatch(onGetClient())
    }
    useEffect(() => {
        getAllClients()
        setReload(0)
    }, [reload]);

    useEffect(() => {
        if (clientStatus?.success?.status?.toLowerCase() === 'success') {
            setDeleteModal(false)
            setReload(prev => prev + 1)
        }
    }, [clientStatus])

    const columns = useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'name'
            },
            {
                Header: 'Client code',
                accessor: 'clientCode',
            },
            {
                Header: 'Email',
                accessor: 'email'
            },
            {
                Header: 'Phone',
                accessor: 'phone'
            },
            {
                Header: 'Active / In-Active ',
                Cell: cellProps => {
                    return (
                        <div>
                            <div className="square-switch text-center d-flex justify-content-center"
                                onClick={() => {
                                    handleClientId(cellProps.row.original);
                                    if (cellProps.row.original.active === true) {
                                        setChecked(false)
                                        setReload(prev => prev + 1)
                                    } else if (cellProps.row.original.active === false) {
                                        setChecked(true)
                                        setReload(prev => prev + 1)
                                    }
                                }}>
                                <input
                                    type="checkbox"
                                    id={`${cellProps.row.original._id}`}
                                    // eslint-disable-next-line react/no-unknown-property
                                    switch="bool"
                                    checked={cellProps.row.original.active}
                                    onChange={() => { }}
                                />
                                <label
                                    htmlFor={`${cellProps.row.original._id}`}
                                    data-on-label="Yes"
                                    data-off-label="No"
                                    className='m-0'
                                />
                            </div>
                        </div>
                    )
                }
            },
            {
                Header: "Action",
                Cell: cellProps => {
                    return (
                        <div className="d-flex gap-3 justify-content-center">
                            <Link
                                to={`/clients/client-details/${cellProps.row.original._id}`}
                                className="view-client-icon d-flex align-items-center">
                                <i className="mdi mdi-eye font-size-18" id="view-tooltip" />
                                <UncontrolledTooltip placement="top" target="view-tooltip">
                                    View
                                </UncontrolledTooltip>
                            </Link>
                            <Link
                                to={`/clients/update-client/${cellProps.row.original._id}`}
                                className="edit-client-icon d-flex align-items-center">
                                <i className="bx bx-edit-alt font-size-18 " id="edittooltip" />
                                <UncontrolledTooltip placement="top" target="edittooltip">
                                    Edit
                                </UncontrolledTooltip>
                            </Link>
                        </div>
                    );
                },
            },
        ],
        []
    );

    //meta title
    document.title = "Clients | Glottis Logistics"; 
    return (

        <div className="page-content client">
            <div className="container-fluid">
                <Breadcrumbs title="Dashboard" dashurl="/dashboard" breadcrumbItem="Clients" />
                <div>
                    {!client.client ? <>
                        <div className='mb-2 p-3'>
                            <Skeleton height={"53px"} width={'180px'} />
                        </div>
                        <TableSkeleton datacount={9} listcount={10} /></> :
                        <TableContainer
                            columns={columns}
                            data={client?.client ? client?.client : []}
                            isGlobalFilter={true}
                            isAddOptions={true}
                            customPageSize={10}
                            handleOrderClicks={newClientRouter}
                            iSPageOptions={true}
                            className="custom-header-css"
                            btnname="Add New Client"
                        />}
                </div>
            </div>  
            <DeleteModal
                show={deleteModal}
                onDeleteClick={() => {
                    clientActiveEvent()
                }
                }
                loader={loader.loaderstatus}
                content={`Are you sure, do you want to ${checked ? 'activate' : 'deactivate'} this client?`}
                okBtnName={checked ? 'Activate' : 'De-Activate'}
                cancelBtnName='Cancel'
                onCloseClick={() => setDeleteModal(false)}
            />
        </div>
    );
}
ClientsList.propTypes = {
    preGlobalFilteredRows: PropTypes.any,

};

export default ClientsList;